import { formatDateWeekday } from "@/utils/publicTracking/format";

interface ExpectedDeliveryCardProps {
  expectedDate: string | null;
  deliveredDate: string | null;
}

/**
 * Dark green delivery card — "Delivered" once delivered, else "Expected
 * delivery". Hidden when there's no date yet (a just-accepted piece).
 */
export function ExpectedDeliveryCard({
  expectedDate,
  deliveredDate,
}: ExpectedDeliveryCardProps) {
  const delivered = deliveredDate != null;
  const primary = delivered ? deliveredDate : expectedDate;
  if (!primary) return null;

  return (
    <div className="shrink-0 rounded-lg bg-emerald-800 px-5 py-4 text-white shadow-sm">
      <p className="text-[10px] font-medium tracking-wider text-white/70 uppercase">
        {delivered ? "Delivered" : "Expected delivery"}
      </p>
      <p className="mt-1 text-3xl font-semibold">
        {formatDateWeekday(primary)}
      </p>
    </div>
  );
}
